import { gql } from "@apollo/client"

export const SUBSCRIPTION_COMMENT = gql`
subscription OnCommentCreated($fbLiveId: String!) {
  onCommentCreated(fbLiveId: $fbLiveId) {
    from {
      id
      name
    }
    commentId
    id
    fbLiveId
    message
    pageId
    postId
  }
}
`; 